module.exports = __webpack_public_path__ + "static/find-mtg-tokens-for-your-deck-a2a59c6a6324d765db5ddef56d59c831.png";